export const ASSIGNEE_PROFILE_ID_NAME = 'assigneeProfileId';
export const RESOURCE_IDS_NAME = 'resourceIds';
export const STATUSES_NAME = 'statuses';
export const TYPES_NAME = 'types';
export const FLOOR_NAMES_NAME = 'floorNames';
